export enum FileType {
    SimpleFile = 'simple file',
    Directory = 'directory',
    ModelFile = 'model file'
};

export type File = {
    id: number;
    url: string | null;
    name: string;
    type: FileType;
    created: number;
    modified: number;
    children?: File[];
    parent?: File;
};

export type GetFileWithSiblingsSuccessResponse = {
    files: File[];
};